module.exports = __webpack_public_path__ + "assets/img/73e0c99c992420f881e88041560468b1.png";